var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C17.5234 2 22 6.47656 22 12C22 17.5234 17.5234 22 12 22C9.87891 22 7.90625 21.3359 6.28516 20.207C5.71875 19.7773 5.57969 19.0312 5.97656 18.4648C6.37109 17.8984 7.14844 17.7617 7.71484 18.1562C8.92969 19.0039 10.4062 19.5 12 19.5C16.1406 19.5 19.5 16.1406 19.5 12C19.5 7.82422 16.1406 4.5 12 4.5C9.89453 4.5 8.05469 5.33828 6.69531 6.69531L7.89844 7.89844C8.48828 8.48828 8.07031 9.5 7.23828 9.5H2.9375C2.41992 9.5 2 9.08203 2 8.5625V4.26328C2 3.42813 3.00977 3.00977 3.60039 3.60039L4.92891 4.92891C6.73828 3.1207 9.23828 2 11.9648 2H12ZM12 7C12.5195 7 12.9375 7.41797 12.9375 7.9375V11.6133L15.4414 14.1484C15.8398 14.5156 15.8398 15.1094 15.4414 15.4414C15.1094 15.8398 14.5156 15.8398 14.1484 15.4414L11.3359 12.6289C11.1602 12.4883 11.0625 12.25 11.0625 12V7.9375C11.0625 7.41797 11.4805 7 12 7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockRotate);
export default __webpack_public_path__ + "static/media/clock-rotate.118af0342d6291eca5eee9974d1fbdca.svg";
export { ForwardRef as ReactComponent };